import React from 'react';

// Minimal tranche-style progress bar rendered as HTML overlay.
// texts: array of {count} objects (same shape used for text progression)
// index: current text index
// counter: current counter value within the active tranche
// color: fill color (should contrast with canvas bg)
const ProgressBar = ({ texts, index, counter, color = 'rgba(255,255,255,0.6)' }) => {
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: 8,
        display: 'flex',
        gap: 2,
        pointerEvents: 'none',
        zIndex: 10,
      }}
    >
      {texts.map((t, i) => {
        let fill = 0;
        if (i < index) {
          fill = 1;
        } else if (i === index) {
          fill = Math.min(counter / t.count, 1);
        }
        return (
          <div
            key={i}
            style={{
              flex: 1,
              backgroundColor: 'rgba(255,255,255,0.12)',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                width: `${fill * 100}%`,
                backgroundColor: color,
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ProgressBar;
